import axios from 'axios';

const api = axios.create({
    //baseURL: 'https://userbox.com.br/ead_api/public/api/'
    baseURL: 'https://las.app.br/ead_api/public/api/'
});

export default api;
